import * as React from 'react';
import styles from './index.less';
import { RouteComponentProps } from 'react-router';
import { history, withRouter } from 'umi';
import { connect } from 'dva';
import * as AHooks from 'ahooks';
import { FServiceAPI, FUtil, FI18n } from '@freelog/tools-lib';
import FIcons from '@/components/FIcons';

interface FreezeProps extends RouteComponentProps<{ id: string }> {

}

interface FreezeStates {
  resourceName: string;
  freezeReason: string;
  isOwner: boolean;
}

function Freeze({ match }: FreezeProps) {

  const [resourceName, set_resourceName] = React.useState<FreezeStates['resourceName']>('');
  const [freezeReason, set_freezeReason] = React.useState<FreezeStates['freezeReason']>('');
  const [isOwner, set_isOwner] = React.useState<FreezeStates['isOwner']>(true);

  AHooks.useMount(() => {
    handleData();
  });

  AHooks.useUnmount(() => {

  });

  async function handleData() {
    const { data }: any = await FServiceAPI.Resource.info({
      resourceIdOrName: match.params.id,
      isLoadFreezeReason: 1,
    });
    // (status & 2 ) === 2
    // console.log(data, 'DDDDDDDDDfo9iwekjlskdfjsdlkj');

    if ((data.status & 2) !== 2) {
      history.replace(FUtil.LinkTo.resourceDetails({ resourceID: match.params.id }));
      return;
    }

    set_resourceName(data.resourceTitle || data.resourceName.split('/')[1]);
    set_freezeReason(data.freezeReason || '其他违法违规');
    set_isOwner(data.userId === FUtil.Tool.getUserIDByCookies());
  }

  return (<div className={styles.container}>
    <FIcons.FForbid className={styles.FForbid} />
    <div style={{ height: 30 }} />
    <div className={styles.content}>
      {
        isOwner
          ? FI18n.i18nNext.tJSXElement('alert_resourceblocked02', {
            ResourceName: resourceName,
            DisableDetails: freezeReason,
          })
          : FI18n.i18nNext.tJSXElement('alert_resourceblocked01', {
            ResourceName: resourceName,
            DisableDetails: freezeReason,
          })
      }
    </div>
  </div>);
}

export default withRouter(connect()(Freeze));
